import { defineMessages } from 'react-intl';

const messages = defineMessages({
  deleteShipment: {
    defaultMessage: 'Delete Shipment',
    id: 'sqQnA9',
    description: 'label for a button that opens a modal which allows the user to delete a shipment',
  },
  shipmentActions: {
    defaultMessage: 'Shipment Actions',
    id: 'AZxHtb',
    description: 'title for a drop down menu that contains actions that can be performed on a shipment',
  },
  deleteModalButton: {
    defaultMessage: 'Delete',
    id: 'p/YJyz',
    description: 'label for a button that allows the user to delete a shipment',
  },
  voidShipment: {
    defaultMessage: 'Void Shipment',
    id: 'vZOvRl',
    description: 'label for a button that opens a modal which allows the user to void a shipment',
  },
  copyTracking: {
    defaultMessage: 'Copy Tracking Number',
    id: 'JBZxBi',
    description: 'label for a button that copies the tracking number of a shipment',
  },
  printShipment: {
    defaultMessage: 'Print',
    id: 'fUHrBy',
    description: 'label for a button that provides the user with printing options for a shipment',
  },
  allocateShipment: {
    defaultMessage: 'Allocate Shipment',
    id: 'IIm4fb',
    description: 'label for a flyout menu which contains actions that allow the user to allocate a shipment',
  },
  allocate: {
    defaultMessage: 'Allocate',
    id: '49DfcP',
    description: 'label for a button that opens a modal which allows the user to allocate an order',
  },
  deallocate: {
    defaultMessage: 'Deallocate',
    id: 'veKg+4',
    description: 'label for a button that opens a modal which allows the user to deallocate an order',
  },
  recommendPackage: {
    defaultMessage: 'Package Recommendation',
    id: 'YIjxrs',
    description: 'label for a button that triggers package recommendation',
  },
});

export default messages;
